import React, { useContext, useEffect } from "react";
import "./Auth.css";
import { useSelector, useDispatch } from "react-redux";
import { setVerifyCode, setAuthTab } from "../Redux/Actions/AuthAction";
import PinInput from "react-pin-input";
import loadingSvg from "../assets/images/techapp/loading-white.svg";
import FormatHelper from "../Helper/FormatHelper";
import { AuthContext } from "../Api/authReq";
import lang from "./lang/lang.json";
import { IoIosArrowForward } from "react-icons/io";

const GetToken = () => {
  const dispatch = useDispatch();
  const userMobile = useSelector((state) => state.AuthReducer.userMobile);

  const { proLogin, getToken, loading, otp } = useContext(AuthContext);

  useEffect(() => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();

      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          getToken(FormatHelper.toEnglishString(otp.code));
          dispatch(setVerifyCode(FormatHelper.toEnglishString(otp.code)));
          ac.abort();
        })
        .catch((err) => {
          ac.abort();
        });
    }
  }, [window]);

  return (
    <form onSubmit={getToken} className="gettoken">
      <div id="otp">{otp}</div>
      <div
        onClick={() => dispatch(setAuthTab(0))}
        className="gettoken-back-to-prologin"
      >
        <span>{lang.CORRECT_MOBILE}</span>
        <IoIosArrowForward style={{ marginLeft: 10 }} />
      </div>
      <div className="gettoken-title">
        <span style={{ fontSize: "22px", marginBottom: "15px" }}>
          {lang.PLEASE_ENTER_SENT_CODE}
        </span>
        <span style={{ fontSize: "16px" }}>
          {lang.MOBILE} : {FormatHelper.toPersianString(userMobile)}
        </span>
      </div>
      <div className="gettoken-code-inputs">
        <PinInput
          length={4}
          focus={true}
          initialValue=""
          disabled={loading}
          type="numeric"
          inputMode="number"
          style={{ padding: "10px" }}
          inputStyle={{
            border: "none",
            backgroundColor: "rgba(255, 255, 255, 0.158)",
            borderRadius: "6px",
            margin: "0 5px",
            width: "60px",
            height: "60px",
            color: "white",
            fontSize: 20,
          }}
          inputFocusStyle={{ border: "1px solid rgba(255, 255, 255, 0.158)" }}
          onChange={(value) => {
            if (value.length === 4) {
              getToken(FormatHelper.toEnglishString(value));
            }
          }}
          onComplete={(value) =>
            dispatch(setVerifyCode(FormatHelper.toEnglishString(value)))
          }
          autoSelect={true}
          regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
        />
      </div>
      {loading ? (
        <img
          style={{ width: "30px", height: "30px" }}
          src={loadingSvg}
          alt="loading"
        />
      ) : (
        <span onClick={proLogin} style={{ cursor: "pointer", opacity: ".7" }}>
          {lang.RESEND_CODE}
        </span>
      )}
    </form>
  );
};
export default GetToken;
